import globalStyles from "../../Styles/global.module.scss";
import classNames from 'classnames';
import styles from "../../Styles/subscribe.module.scss";
import { useAuth } from '../../contexts/AuthContext';

function Subscribe({ hasActiveLicense = false, hadActiveLicense = false }) {

  const { user } = useAuth();

  const handleSubscribe = (planType) => {
    if (!user) {
      alert('Please sign in first');
      return;
    }

    // test products
    // const checkoutUrls = {
    //   monthly: 'https://store.no61.app/buy/634f2b31-0b52-4ec3-832f-baf54288fb76',
    //   yearly: 'https://store.no61.app/buy/fee036e6-8fee-4363-8ee5-2bf03ba0e2d7'
    // };

    const checkoutUrls = {
      daily: 'https://store.no61.app/buy/4fe06a0f-f5ab-434e-bc79-0d332c367084',
      monthly: 'https://store.no61.app/buy/caa4020b-c780-4350-85bb-28f5f5e94fd3',
      yearly: 'https://store.no61.app/buy/c959a84c-99f6-4841-b043-9cad345b0d3d'
    };

    const checkoutUrl = checkoutUrls[planType];

    // Add user email as a parameter so it's pre-filled
    const urlWithEmail = `${checkoutUrl}?checkout[email]=${encodeURIComponent(user.email)}`;

    // Open checkout in new tab
    window.open(urlWithEmail, '_blank');
  };


  return (
    <div className={classNames(styles.subscribePopup, {
      [styles.hasActiveLicense]: hasActiveLicense,
      [styles.hadActiveLicense]: hadActiveLicense
    })}>

      {/* <h4 className={styles.subTitle}>Start your premium journey today</h4> */}

      <div className={styles.productsContainer}>

        {/* monthly */}
        <div className={classNames(styles.product, styles.productMonthly)} onClick={() => handleSubscribe('monthly')}>
          <div>
            <p className={styles.productTitle}>
              <strong>Monthly</strong> - Flexible
            </p>
            <span className={styles.productSubTitle}>All The Perks, Full Control</span>
          </div>

          <div>
            <p className={styles.price}>
              $3
              <span className={styles.priceDecimal}>75</span>
              <span className={styles.priceProductType}>/ month</span>
            </p>
            {/* <p className={styles.vat}>(excl. VAT)</p> */}
          </div>

          <button className={classNames(styles.subscribeBtnMonthly, globalStyles.priBtn)}>
            <span>Subscribe</span>
          </button>
        </div>

        {/* yearly */}
        <div className={classNames(styles.product, styles.productYearly)} onClick={() => handleSubscribe('yearly')}>
          <span className={styles.label}>
            4 Months for Free
          </span>
          <div>
            <p className={styles.productTitle}>
              <strong>Yearly</strong> - Best Value
            </p>
            <span className={styles.productSubTitle}>All The Perks, Biggest Savings</span>
          </div>

          <div>
            <p className={styles.price}>
              $26
              <span className={styles.priceDecimal}>95</span>
              <span className={styles.priceProductType}>/ year</span>
            </p>
            {/* <p className={styles.vat}>(excl. VAT)</p> */}
            <p className={styles.savingsAccent}>Get 4 Months for Free</p>
          </div>

          <button className={classNames(styles.subscribeBtnYearly, globalStyles.priBtn)}>
            <span>Subscribe</span>
          </button>
        </div>

        {/* 24-Hour */}
        {!hasActiveLicense && !hadActiveLicense ? (
          <div className={classNames(styles.product, styles.productDaily)}
            onClick={() => {
              if (hasActiveLicense || hadActiveLicense) return;
              handleSubscribe('daily');
            }}
          >
            <span className={styles.dailyProductSeperator}></span>
            <div>
              <p className={styles.productTitle}>
                <strong>Get 24-Hour Access</strong>
              </p>
              <span className={styles.productSubTitle}>Try All Features, No Commitment</span>
            </div>

            <div>
              <p className={styles.price}>
                $1
                <span className={styles.priceDecimal}>95</span>
                <span className={styles.priceProductType}></span>
              </p>
              {/* <p className={styles.vat}>(excl. VAT)</p> */}

              <span className={styles.productLimit}>One-time purchase only<br />(Figma plugin access excluded)</span>
            </div>


            <button className={classNames(styles.subscribeBtnDaily, globalStyles.secBtn)}>
              <span>Try now</span>
            </button>
          </div>
        ) : null}

      </div>
    

      <div>
        <h3 className={styles.title}>Unlock Pro Features
        </h3>
      </div>

      <div className={styles.cancellation}>
        <svg className={styles.cancellationIcon} width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
        </svg>
        <span>Cancel anytime. No hidden fees.</span>
      </div> 

      {/* <div>
        <h4 className={styles.subTitle}>Start your premium journey today</h4>
      </div> */}


      {/* <div className={styles.videoContainer}>
        <video
          preload="metadata"
          autoPlay
          muted
          loop
          playsInline
          disablePictureInPicture
          style={{ width: '100%', maxWidth: '100%' }}
        >
          <source src="/PremiumFeatures.mp4" type="video/mp4" />
          Your browser doesn't support the video tag.
        </video>
      </div> */}

      <div>
        <span className={styles.perksTitle}>
          Everything you get
          <svg className={styles.perksTitleIcon} width={20} height={20} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
          </svg>
        </span>
        <ul className={styles.perksList}>
          <li className={styles.perksListItem}>Generate shareable links to present your color scales or palettes to clients</li>
          <li className={styles.perksListItem}>Add and preview secondary & tertiary color scales</li>
          <li className={styles.perksListItem}>Save scales or palettes directly to your account for quick access</li>
          <li className={styles.perksListItem}>Instantly check accessibility with our built-in Contrast Grid</li>
          <li className={styles.perksListItem}>Export in OKLCH, HSL and RGB format (incl. SCSS and CSS)</li>
          <li className={styles.perksListItem}>Generate both individual scales and complete palettes</li>
          <li className={styles.perksListItem}>Fine-tune or reset individual variable colors by hue, saturation, or lightness</li>
          <li className={styles.perksListItem}>Fine-tune or reset scale colors by hue, saturation, or lightness</li>
          <li className={styles.perksListItem}>Get access to all premium features in the <a className={styles.figmaPluginLink} href="https://www.figma.com/community/plugin/1544422242387734389" target="_blank" rel="noopener noreferrer">No61 Figma plugin</a></li>
          <li className={styles.perksListItem}>Get access to duo and trio palette themes</li>
        </ul>
      </div>
    </div>
  )
}

export default Subscribe